import RouterLink from '~components/generic/RouterLink';

export function BreadcrumbItem({ title, url }: SearchResultsItemBreadcrumbItem) {
  if (!url) {
    return <span className="text-black font-sans text-sm leading-none cursor-default">{title}</span>;
  }
  return (
    <RouterLink to={url} className="no-underline hover:underline text-black font-sans text-sm leading-none">
      {title}
    </RouterLink>
  );
}
